import icon1 from '../../../Assets/icon_card_wiseprevent_1.png'
import icon2 from '../../../Assets/icon_card_wiseprevent_2.png'
import icon3 from '../../../Assets/icon_card_wiseprevent_3.png'
import icon4 from '../../../Assets/icon_card_wiseprevent_4.png'
import icon5 from '../../../Assets/icon_card_wiseprevent_5.png'
import icon6 from '../../../Assets/icon_card_wiseprevent_6.png'
import logo from '../../../Assets/whatsign_logo3.png'
import img1 from '../../../Assets/Whatsign_Imagem_1.png'
import img2 from '../../../Assets/Whatsign_Imagem_2.png'
import { HeroSection } from '../Components/HeroSection'
import { CardSection } from '../Components/CardSection'
import { ValueSection } from '../Components/ValueSection'
import { FaqSection } from '../Components/FaqSection'

const CARDS = [
  {
    icon: icon1,
    title: "Assinatura via WhatsApp",
    text: "Envios e assinaturas diretas pelo aplicativo mais popular do país.",
  },
  {
    icon: icon2,
    title: "Autenticação Segura",
    text: "Valide identidades com protocolos criptográficos e registros auditáveis.",
  },
  {
    icon: icon3,
    title: "Gestão de Documentos",
    text: "Centralize contratos e históricos com rastreabilidade completa.",
  },
  {
    icon: icon4,
    title: "Validade Jurídica",
    text: "Total conformidade com a legislação brasileira e internacional.",
  },
  {
    icon: icon5,
    title: "Relatórios de Auditoria",
    text: "Acompanhe status e trilhas de assinatura em tempo real.",
  },
  {
    icon: icon6,
    title: "Fluxos Personalizados de Aprovação",
    text: "Configure diferentes níveis de assinatura e aprovação conforme a hierarquia e tipo de documento.",
  },
];

const BLOCKS = [
  {
    title: "Resultados que vão além da operação",
    text:
      `Formalização digital mais ágil, segura e confiável, com redução de tempo e custos operacionais.`,
    bullets: [
      {
        title: "Confiabilidade jurídica e técnica.",
        text: ""
      },
      {
        title: "Facilidade de uso e integração.",
        text: ""
      },
      {
        title: "Assinaturas rápidas e seguras.",
        text: ""
      },
    ],
    img: img2,
  },
];

const FAQ = [
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'Aliquam sit amet odio faucibus, sodales metus placerat, pharetra tortor. Donec ornare urna et tellus rhoncus gravida. Mauris efficitur purus sed ipsum pretium aliquet.'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
]
export const Whatsign = () => {
  return (
    <div>
      <HeroSection
        logo={logo}
        title='Assinatura digital que une confiança, leveza e praticidade'
        text='A WhatSign digitaliza processos de assinatura com foco em segurança, agilidade e experiência do usuário.'
        colorBtn='--color-63c45c'
        url='https://www.google.com.br/'
        img={img1}
      />

      <CardSection
        cards={CARDS}
        title='Simplifique a formalização de documentos e contratos de forma segura e legal'
        text='Com a WhatSign, empresas reduzem burocracias e ganham agilidade em processos de assinatura digital.'
      />

      <ValueSection
        blocks={BLOCKS}
      />

      {/* <FaqSection
        title="Suas principais dúvidas, respondidas"
        text={[
          'Com a WisePrevent, você reduz custos, prolonga a vida útil dos ativos e tem total controle do que foi feito, por quem e quando.',
          'Tudo rastreável, auditável e pronto para apresentar à gestão ou aos órgãos reguladores.'
        ]}
        colorBtn='--color-ff7022'
        faq={FAQ}
      /> */}

    </div>
  )
}
